export const formatPenceToPounds = (pence: number | null | undefined): string => {
  if (pence === null || pence === undefined) return '-';
  return `£${(pence / 100).toFixed(2)}`;
};

export const getBillingTypeLabel = (
  billingType: 'FIXED' | 'PER_UNIT' | null | undefined,
): string => {
  if (!billingType) return '-';
  switch (billingType) {
    case 'FIXED':
      return 'Fixed';
    case 'PER_UNIT':
      return 'Per unit';
    default:
      return billingType;
  }
};

export const isBillingActive = (billingStartDate: string | null | undefined): boolean => {
  if (!billingStartDate) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return new Date(billingStartDate + 'T00:00:00') <= today;
};

/** Billing is raised on the first of a month, so a run prepared in September is charged on 1 October. */
export const nextBillingMonth = (today: Date = new Date()): Date =>
  new Date(today.getFullYear(), today.getMonth() + 1, 1);

export const formatBillingMonth = (month: Date): string =>
  month.toLocaleDateString('en-GB', { month: 'long', year: 'numeric' });

export type MrrSummary = {
  active: number;
  pending: number;
  total: number;
};

/**
 * Active MRR is what is already being billed; pipeline is configured but not yet started.
 * Shared by the billing tab and the usage dashboard so the two can never disagree.
 */
export const summariseMrr = (
  rows: readonly {
    monthlyBillPence: number | null;
    billingStartDate: string | null;
    isInternal: boolean;
  }[],
  showInternal: boolean,
): MrrSummary => {
  let active = 0;
  let pending = 0;

  for (const row of rows) {
    if (!showInternal && row.isInternal) continue;
    const bill = row.monthlyBillPence ?? 0;
    if (!bill) continue;

    if (isBillingActive(row.billingStartDate)) {
      active += bill;
    } else {
      pending += bill;
    }
  }

  return { active, pending, total: active + pending };
};
